module.exports = __webpack_public_path__ + "img/trailer (4).da83dc55.jpg";